module.exports = __webpack_public_path__ + "static/media/two-men-buttering-rolls.0b231e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2019-10-18/two-men-buttering-rolls.jpg
// module id = 821
// module chunks = 0